export default __webpack_public_path__ + "static/ubuntu-v20-latin-700-7ceec6fd3e7d00630b2568986c915532.woff2";